export default __webpack_public_path__ + "static/media/heart-red-icon.a4650c46.svg";